'use strict';

import 'angulartics';
import 'angulartics-piwik';

/* Module */
export default angular.module('conduu.ap.analytics', ['angulartics', 'angulartics.piwik'])
  .name;



// WEBPACK FOOTER //
// ./client/~ap/app/analytics/index.js